/** 首页 */
export default {
    frontPage: "front page", // 首页
    day: "day", // 日
    week: "week", // 周
    month: "month", // 月
    year: "year", // 年
    PCS: "PCS", // 设备台数
    cumulativeTrafficOverview: "Cumulative traffic overview", // 累计客流概览
        cumulativePassengerFlowToday:"Cumulative passenger flow today", // 今日累计客流 Cumulative passenger flow today
        comparedToYesterday: "compared to yesterday", // 较昨日 compared to yesterday
        cumulativePassengerFlowThisMonth: "Cumulative passenger flow this month", // 本月累计客流 Cumulative passenger flow this month
        comparedWithLastMonth: "Compared with last month", // 较上月 Compared with last month
        cumulativePassengerFlowThisYear: "Cumulative passenger flow this year", // 本年累计客流 Cumulative passenger flow this year
        comparedToLastYear: "compared to last year", // 较去年 compared to last year
        cumulativePassengerFlowYesterday: "Cumulative passenger flow yesterday", // 昨日累计客流 Cumulative passenger flow yesterday
        cumulativePassengerFlowLastMonth: "Cumulative passenger flow last month", // 上月累计客流 Cumulative passenger flow last month
        cumulativePassengerFlowLastYear: "Cumulative passenger flow last year", // 去年累计客流 Cumulative passenger flow last year
        overviewOfDeviceInformation: "Overview of device information", // 设备信息概览 Overview of device information
            onlineDevice: "online device", // 在线设备 online device
            offlineDevice: "offline device", // 离线设备 offline device
            total: "total", // 总数 total
    announcement: "announcement", // announcement
        viewAll: "view all", //查看全部 view all
    entityPassengerFlow: "Entity passenger flow (only query the top 10)", // Entity passenger flow (only query the top 10) 实体客流(只查询排行前10)
    listOfPhysicalPassengerFlow: "List of physical passenger flow", // 实体客流一览 List of physical passenger flow
    toDayPassenger: "to Day Passenger", // 当日客流
    toMonthPassenger: "to month passenger", // 当月客流
    toYearPassenger: "to year passenger", // 当年客流
    totalPassenger: "total passenger", // 累计客流
    passengerFlowPerson: "passenger flow (person)", // 客流(人)
    time: "time", // 时间
}